import { Component, OnInit } from '@angular/core';

// Components
import { ProceduresButtonsComponent } from 'src/app/modules/procedures/views/procedures-buttons/procedures-buttons.component';
import { ProceduresListComponent } from 'src/app/modules/procedures/views/procedures-list/procedures-list.component';

@Component({
  selector: 'app-procedures',
  templateUrl: './procedures.component.html',
  styleUrls: ['./procedures.component.scss']
})
export class ProceduresComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
